var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SectionTitle',{attrs:{"content":_vm.model.name,"has-line":true}}),_vm._l((_vm.model.questions),function(item){return _c('Question',{key:item.id,attrs:{"section":_vm.model,"model":item,"readonly":_vm.readonly},on:{"selected":_vm.onClickChild}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }